import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface VideoPlaySmallProps extends IconWrapperProps {
  onClick?: () => void;
  color?: string;
}

const VideoPlaySmall = ({ color = '#fff', ...rest }: VideoPlaySmallProps) => {
  return (
    <IconWrapper
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      title="Icons/UI 24/Video-Play-Small"
      {...rest}
    >
      <defs>
        <path
          d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 Z M10.1631089,7.10171016 L17.4069499,11.5126701 C17.8226834,11.7625829 17.8226834,12.2873997 17.4069499,12.5373124 L10.1631089,16.8982898 C9.7599734,17.1357069 9.28125,16.9357767 9.28125,16.5234207 L9.28125,7.47657928 C9.28125,7.06422325 9.7599734,6.86429306 10.1631089,7.10171016 Z"
          id="path-1"
        ></path>
        <filter
          x="-100.0%"
          y="-100.0%"
          width="300.0%"
          height="300.0%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur
            stdDeviation="8"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.4 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Icons/UI-24/Video-Play-Small"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect id="Rectangle" fillOpacity="0" fill={color} x="7" y="7" width="10" height="10"></rect>
        <g id="Combined-Shape">
          <use fill="black" fillOpacity="1" filter="url(#filter-2)" xlinkHref="#path-1"></use>
          <use fill={color} fillRule="evenodd" xlinkHref="#path-1"></use>
        </g>
      </g>
    </IconWrapper>
  );
};

export default VideoPlaySmall;
